import React, { Component, Fragment, useState } from "react";
import { useMediaQuery } from "@react-hook/media-query";
import { useMeasure } from "react-use";
import { Toaster } from "react-hot-toast";

import { getDashboardData } from "../services/dashboard";

import useRoutingState from "../hooks/useRoutingState";

import DashboardSelector from "./components/DashboardSelector";
import HealthSection from "./components/HealthSection";
import OverallHealth from "./components/OverallHealth";
import TeamHealth from "./components/TeamHealth";
import IndividualTeamStage from "./components/IndividualTeamStage";
import SelfReportedTeamMetrics from "./components/SelfReportedTeamMetrics";
import LeadershipHealth from "./components/LeadershipHealth";
import DevelopmentPlan from "./components/DevelopmentPlan";

import Blur from "../commons/Blur";
import ChatMessage from "../Chat/ChatMessage";

const Personal = ({ user, teams, isTeamLeadOrAbove, data }) => {
  useRoutingState();
  
  const {
    user_health,
    user_stage,
    development_plan
  } = data;

  const showTopChat = useMediaQuery("screen and (max-width: 1535px)");

  const [dashboardCardsRef, dashboardCardsMeasure] = useMeasure();

  const [chatExpanded, setChatExpanded] = useState(false);

  const dashboard = getDashboardData(user_health);

  const handleChatExpandClick = () => {
    setChatExpanded(!chatExpanded);
  }

  const renderFirstRow = () => {
    if (chatExpanded) return null;
    return (
      <div className="dashboard-row">
        <OverallHealth ofuscate />
        <IndividualTeamStage stage={user_stage} />
        <DevelopmentPlan plan={development_plan} />
      </div>
    );
  }

  const renderSecondRow = () => {
    if (chatExpanded) return null;
    return (
      <div className="dashboard-row">
        <TeamHealth ofuscate />
      </div>
    );
  }

  const renderThirdRow = () => {
    if (chatExpanded) return null;
    return (
      <div className="dashboard-row">
        <HealthSection {...dashboard.my_health} />
      </div>
    );
  }

  const renderFourthRow = () => {
    if (chatExpanded) return null;
    return (
      <div className="dashboard-row">
        <SelfReportedTeamMetrics ofuscate />
        <LeadershipHealth ofuscate />
      </div>
    );
  }

  const renderChatSection = (top = false) => {
    let className = top ? "dashboard-top-chat" : "dashboard-chat";
    className = chatExpanded ? className + " chat-expanded" : className;
    return (
      <div className={className} style={{ maxHeight: dashboardCardsMeasure.height }}>
        <ChatMessage
          user={user}
          expand={!top}
          showSuggestions
          onChatExpandClick={handleChatExpandClick}
        />
      </div>
    );
  }
    
  return (
    <Fragment>
      <div className="wrapper">
        <div className="dashboard">
          <div className="container-fluid">
            <div className="dashboard-row selector">
              <DashboardSelector
                user={user}
                teams={teams}
                isTeamLeadOrAbove={isTeamLeadOrAbove}
                personal
              />
            </div>
            {showTopChat ? renderChatSection(true) : null}
            <div className={chatExpanded ? "dashboard-content chat-expanded" : "dashboard-content"}>
              <div
                className={chatExpanded ? "dashboard-cards chat-expanded" : "dashboard-cards"}
                ref={dashboardCardsRef}
              >
                {renderFirstRow()}
                {renderSecondRow()}
                {renderThirdRow()}
                {renderFourthRow()}
              </div>
              {!showTopChat ? renderChatSection() : null}
            </div>
          </div>
        </div>
        <Blur />
      </div>
      <Toaster
        position="top-right"
        reverseOrder
      />
    </Fragment>
  );
}

// NOTE: needed now to current version of ReactOnRails to work with hooks
export default class PersonalComponent extends Component {
  render() {
    return <Personal {...this.props} />;
  }
}
